import React from 'react';
import Button from '@material-ui/core/Button';
import { Link } from 'react-router-dom';

const LinkItem = props => <Link to={props.path} {...props} />;

const ButtonLink = props => (
  <Button component={LinkItem} {...props}>
    {props.children}
  </Button>
);

export default ButtonLink;
